import {
  Injectable,
  ErrorHandler,
  InjectionToken,
  Inject,
} from '@angular/core';
import Rollbar from 'rollbar';
import {AppSettings} from '../../proyect.conf';

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: AppSettings.rollbaraAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureEmail: true,
  captureIp: true,
  captureUsername: true,
  environment: AppSettings.nameEnviroment,
  enabled: AppSettings.produccion ? true : false,
  ignoredMessages: ['Script error.'],
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');
